import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteContact } from '../../api/crmApi';
import { companiesKeys } from '../companies/keys';

import { contactsKeys, contactsMutationKeys } from './keys';

/**
 * Soft-delete a CRM contact (moves it to the trash). Invalidates the contacts
 * caches plus the company list/detail caches, since company detail carries the
 * contact arrays and contact counts shown in the companies view.
 */
export function useDeleteContact() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: contactsMutationKeys.delete,
		mutationFn: deleteContact,
		onSettled: () => {
			qc.invalidateQueries({ queryKey: contactsKeys.all });
			qc.invalidateQueries({ queryKey: companiesKeys.all });
		},
	});
}
